import { AxiosInstance } from 'axios';
import requestTrading from 'config/requestTrading';
import {
  API_SECURITIES_GENERAL_URL,
  API_TRADING_URL,
  API_TRADING_URL_V2,
} from 'constants/api';
import { UserTargetAPI } from 'constants/trading';
import { getTargetAPI } from 'features/securities/utils';

export const tradingApiInstance = {
  [UserTargetAPI.LEGACY]: requestTrading(API_TRADING_URL, false, false),
  [UserTargetAPI.NEW_CORE]: requestTrading(API_TRADING_URL_V2, false, false),
  general: requestTrading(API_SECURITIES_GENERAL_URL),
};

export const getTradingApiInstance = (): AxiosInstance => {
  const targetAPI = getTargetAPI();
  return tradingApiInstance[targetAPI];
};
